import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ConsentDataObject } from 'models/service';

type ConsentsRequest = {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Keys are defined by Backend API endpoint
  consent_ids?: string[];
};

export const getConsents = async (params?: ConsentsRequest) =>
  apiClient.get<ConsentDataObject[], ApiClientResponse<ConsentDataObject[]>>(routes.consents.find, { params });
